"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

var sc = _interopRequireWildcard(require("./Spinner.styles"));

var spinnerSize = {
  large: "spinner--large",
  medium: "spinner--medium",
  small: "spinner--small"
};

var Spinner = function Spinner(_ref) {
  var a11yText = _ref.a11yText,
      className = _ref.className,
      caption = _ref.caption,
      size = _ref.size,
      moreProps = (0, _objectWithoutProperties2["default"])(_ref, ["a11yText", "className", "caption", "size"]);
  var rootClasses = (0, _classnames["default"])(className, spinnerSize[size]);
  var bestAria = a11yText || caption || "Loading"; // TODO: l10n

  return /*#__PURE__*/_react["default"].createElement(sc.Spinner, (0, _extends2["default"])({
    className: rootClasses
  }, moreProps, {
    "data-pka-anchor": "spinner"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "spinner__visual"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "spinner__caption"
  }, caption), /*#__PURE__*/_react["default"].createElement("div", {
    className: "spinner__aria-alert",
    role: "alert",
    "aria-live": "polite"
  }, bestAria));
};

Spinner.types = {
  size: constants.defaultSize
};
var propTypes = {
  /** Descriptive a11y text for assistive technologies. By default, text from children node will be used. */
  a11yText: _propTypes["default"].string,

  /** Sets the className for the spinner */
  className: _propTypes["default"].string,

  /** Sets the caption that will display beneath the spinner */
  caption: _propTypes["default"].string,

  /** Sets the size of the spinner */
  size: _propTypes["default"].oneOf([Spinner.types.size.SMALL, Spinner.types.size.MEDIUM, Spinner.types.size.LARGE])
};
var defaultProps = {
  a11yText: null,
  className: null,
  caption: null,
  size: Spinner.types.size.MEDIUM
};
Spinner.displayName = "Spinner";
Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;
var _default = Spinner;
exports["default"] = _default;
//# sourceMappingURL=Spinner.js.map